// IDs opacos gerados no cliente: aleatórios via CSPRNG, sem timestamp
// embutido (não enumeráveis, não revelam ordem/volume de criação).
// 96 bits de entropia — sem risco prático de colisão.
export function newId(prefix = ''): string {
  const bytes = new Uint8Array(12)
  crypto.getRandomValues(bytes)
  let rand = ''
  for (const b of bytes) {
    rand += b.toString(16).padStart(2, '0')
  }
  return prefix ? `${prefix}-${rand}` : rand
}
